import {useCallback, useState} from 'react';

export const useDialog = (): {
  isOpen: boolean;
  onOpen: () => void;
  onClose: () => void;
} => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const onClose = useCallback(() => {
    setIsOpen(false);
  }, []);

  const onOpen = useCallback(() => {
    setIsOpen(true);
  }, []);
  return {isOpen, onOpen, onClose};
};

export type useDialogReturnType = Omit<ReturnType<typeof useDialog>, 'onOpen'>;
